<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="toc"><a class="xref" href="#/chirafalow0006#intro">Introduction</a></p>
<p class="toc" style="margin-bottom:0;"><a class="xref" href="#/chirafalow0007#ch01">Chapter 1</a></p>
<p class="toc1" style="margin-left:0.25em;">Similar Technologies, Different Schools</p>
<p class="toc" style="margin-bottom:0;"><a class="xref" href="#/chirafalow0008#ch02">Chapter 2</a></p>
<p class="toc1" style="margin-left:0.25em;">Disciplining Play</p>
<p class="toc" style="margin-bottom:0;"><a class="xref" href="#/chirafalow0009#ch03">Chapter 3</a></p>
<p class="toc1" style="margin-left:0.25em;">Where Disciplinary Orientations Come From</p>
<p class="toc" style="margin-bottom:0;"><a class="xref" href="#/chirafalow0010#ch04">Chapter 4</a></p>
<p class="toc1" style="margin-left:0.25em;">Schools as Socializing Agents for Digital Participation</p>
<p class="toc"><a class="xref" href="#/chirafalow0011#conc">Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/chirafalow0012#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chirafalow0013#app">Appendix: Methodology</a></p>
<p class="tocbm"><a class="xref" href="#/chirafalow0014#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chirafalow0015#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-rafalow-0005.vue?6e39681f